import {PublishingRecordForButton} from 'template-collectibles/publishing-ui/graphql/types';
import {TemplatePublishingButtonProps} from 'template-collectibles/publishing-ui/TemplatePublishingButton';
import {PublishableVersionStatus} from 'template-collectibles/publishing-ui/TemplatePublishingConstants';

type PublishingButtonInfo = Pick<
  TemplatePublishingButtonProps,
  'versionName' | 'versionModifiedAt' | 'status'
>;

export function getPublishableInfoForPublishingButton(
  publishingRecords: Array<PublishingRecordForButton>,
  versionApiId: string,
  versionModifiedAt: string,
  isCurrentVersion: boolean
): PublishingButtonInfo {
  const baseResult = {
    versionModifiedAt,
  };
  // Try to find a publishing record for the specified version. This indicates that the version was published
  const publishingRecord = publishingRecords.find((pr) => pr.publishableVersionId === versionApiId);
  if (publishingRecord) {
    return {
      ...baseResult,
      versionName: publishingRecord.versionName,
      status:
        PublishableVersionStatus[publishingRecord.publishingStatus as keyof typeof PublishableVersionStatus],
    };
  }

  return {
    ...baseResult,
    status: isCurrentVersion ? PublishableVersionStatus.DRAFT : PublishableVersionStatus.DRAFT_NON_CURRENT,
  };
}

/**
 * Returns the record for the version that is currently in effect, or `null` when the publishable has none
 * (never published, or the most recent record has since been withdrawn). At most one record can be effective
 * at a time, because publishing a version supersedes the previously effective one.
 */
export function getEffectivePublishingRecord(
  publishingRecords: Array<PublishingRecordForButton>
): PublishingRecordForButton | null {
  return publishingRecords.find((pr) => pr.publishingStatus === PublishableVersionStatus.EFFECTIVE) ?? null;
}
